import React from "react";
import { CheckCircle2, ChevronRight, ThumbsDown, ThumbsUp } from "lucide-react";

const includesUser = (votes, userId) => {
  if (!userId || !Array.isArray(votes)) return false;
  const uid = String(userId);
  return votes.some((v) => String(typeof v === "string" ? v : v?._id) === uid);
};

const PollOption = ({
  voteKey,
  label,
  count,
  pct,
  color,
  selected,
  total,
  isLeading,
  onPress,
}) => {
  const hasVotes = total > 0;
  return (
    <button
      type="button"
      className={`bc-poll-option${selected ? " is-selected" : ""}${
        isLeading ? " is-leading" : ""
      }`}
      style={{
        "--poll-option-color": color,
        borderColor: selected ? color : undefined,
      }}
      onClick={onPress}
    >
      {hasVotes ? (
        <span
          className="bc-poll-option-fill"
          style={{ width: `${Math.max(pct, 4)}%` }}
          aria-hidden
        />
      ) : null}
      <span className="bc-poll-option-row">
        <span className="bc-poll-option-left">
          <span className={`bc-poll-option-icon${selected ? " is-selected" : ""}`}>
            {selected ? (
              <CheckCircle2 size={14} />
            ) : voteKey === "yes" ? (
              <ThumbsUp size={13} />
            ) : (
              <ThumbsDown size={13} />
            )}
          </span>
          <span className="bc-poll-option-copy">
            <strong>{label}</strong>
            <small>
              {hasVotes
                ? `${count} ${count === 1 ? "vote" : "votes"}`
                : "Tap to vote"}
            </small>
          </span>
        </span>
        {hasVotes ? (
          <span className="bc-poll-option-right">
            <em>{pct}%</em>
            {isLeading && total >= 2 ? <span>Leading</span> : null}
          </span>
        ) : (
          <ChevronRight size={14} className="bc-poll-option-chevron" />
        )}
      </span>
    </button>
  );
};

const ChatPollCard = ({ msg, userId, onVote, isMine }) => {
  const yes = msg.poll?.yesVotes?.length || 0;
  const no = msg.poll?.noVotes?.length || 0;
  const total = yes + no;
  const yesPct = total > 0 ? Math.round((yes / total) * 100) : 0;
  const noPct = total > 0 ? 100 - yesPct : 0;
  const votedYes = includesUser(msg.poll?.yesVotes, userId);
  const votedNo = includesUser(msg.poll?.noVotes, userId);
  const msgKey = msg._id || msg.tempId;

  return (
    <div className={`bc-poll bc-poll-lounge${isMine ? " bc-poll-mine" : ""}`}>
      <p className="bc-poll-q">{msg.poll?.question}</p>
      <div className="bc-poll-options">
        <PollOption
          voteKey="yes"
          label="Yes"
          count={yes}
          pct={yesPct}
          color="#34d399"
          selected={votedYes}
          total={total}
          isLeading={total > 0 && yes >= no}
          onPress={() => onVote?.(msgKey, "yes")}
        />
        <PollOption
          voteKey="no"
          label="No"
          count={no}
          pct={noPct}
          color="#f87171"
          selected={votedNo}
          total={total}
          isLeading={total > 0 && no > yes}
          onPress={() => onVote?.(msgKey, "no")}
        />
      </div>
      {total > 0 ? (
        <p className="bc-poll-total">{total} total {total === 1 ? "vote" : "votes"}</p>
      ) : null}
    </div>
  );
};

export default ChatPollCard;
